import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import BookEvent from './pages/BookEvent';
import WhatWeServe from './pages/WhatWeServe';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<BookEvent />} />
          <Route path="/menu" element={<WhatWeServe />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
